import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutTkv2OrderFeaturesAPI } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { orderFeaturesMutationComplete } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export function useOrderFeaturesSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: orderFeaturesMutate } = usePutTkv2OrderFeaturesAPI();

  const orderFeatures = useAppSelector((state) => state.order.orderFeatures);
  const { editRevision = 0, serverRevision = 0 } =
    useAppSelector((state) => state.order.orderFeaturesSync) ?? {};

  const onSuccess = () => {
    dispatch(
      orderFeaturesMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(orderFeaturesMutationComplete({ status: 'error' }));
  };

  const mutate = () =>
    orderFeaturesMutate(
      {
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.ORDER_FEATURES_API.PUT.REQUEST.BODY.parse({
          version: 1,
          features: orderFeatures,
        }),
      },
      { onSuccess, onError },
    );

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
}
